import Experience from "./Experience/Experience";
import "./style.css";

new Experience(document.querySelector("canvas.webgl"));
